(function () {
  'use strict';
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('#cart-note-trigger');
    if (!trigger) return;

    const body = document.getElementById('cart-note-body');
    const textarea = document.getElementById('cart-note-input');
    if (!body || !textarea) return;

    const isOpen = trigger.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      trigger.setAttribute('aria-expanded', 'false');
      body.setAttribute('hidden', '');
    } else {
      trigger.setAttribute('aria-expanded', 'true');
      body.removeAttribute('hidden');
      setTimeout(() => textarea.focus(), 100);
    }
  });

  let debounceTimer;
  document.addEventListener('input', function (event) {
    if (event.target.id !== 'cart-note-input') return;

    const textarea = event.target;
    const charsEl = document.getElementById('cart-note-chars');
    const savedBadge = document.getElementById('cart-note-saved');

    if (charsEl) charsEl.textContent = textarea.value.length;

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ note: textarea.value })
      })
      .then(res => {
        if (!res.ok) throw new Error();
        if (savedBadge) {
          savedBadge.removeAttribute('hidden');
          setTimeout(() => savedBadge.setAttribute('hidden', ''), 2000);
        }
      })
      .catch(err => console.warn('[cart-note] Save failed:', err));
    }, 800);
  });
})();